<script setup lang="ts">
import Image404 from '~~/public/img/404.svg?component'

const error = useError()

if (error.value?.statusCode === 404) {
  error.value.message =
    'The page, or resource, you are looking for might have been removed, had its name changed, or is temporarily unavailable.'
}

const onButtonClick = async () => {
  await clearError({ redirect: '/' })
}
</script>

<template>
  <div class="flex flex-col items-center justify-center h-dvh w-dvh gap-6 p-8">
    <Image404 class="w-2/3 h-auto lg:w-1/3" alt="404 Image" loading="lazy" />

    <h1 class="text-trail-title2 lg:text-trail-title1 text-center">
      Whoops! There was a technical error
    </h1>

    <p class="inline-flex justify-center items-center gap-2">
      Status code:
      <span class="text-trail-title4">{{ error?.statusCode }}</span>
    </p>

    <p class="text-center">{{ error?.message }}</p>

    <TrailDSButton @click="onButtonClick"> Go to homepage </TrailDSButton>
  </div>
</template>
